export default __webpack_public_path__ + "static/banner-software-consulting-0a8c1cd1987cf97a8ba842c3cbb7693b.jpg";